import React, { lazy } from 'react';
import { AuthRoute } from '../auth/components';
import { USER_ROLE } from '@utils/authorisation';


const UsersDashboard = lazy(() => import('./pages/UsersDashboard'));
const UserEditPage = lazy(() => import('./pages/UserEditPage'));

const usersModule = {
  routes: [
    <AuthRoute key="users" exact path="/users" component={UsersDashboard} headerType={'private'} isSpecialistOnly authorization={[USER_ROLE.Admin]} />,
    <AuthRoute key="user-edit" exact path="/user-edit/:userId" component={UserEditPage} headerType={'private'} isSpecialistOnly authorization={[USER_ROLE.Admin]} />,
  ],
};

export default usersModule;
